export default "__VITE_ASSET__C8vxCgtD__"